import Storage from './Storage'

enum GoogleDriveData {
  LAST_SYNC_TIME = 'gdrive_last_sync_time'
}

class GoogleDriveStorage extends Storage<GoogleDriveData> {
  private static instance?: GoogleDriveStorage

  private constructor() {
    super()
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new GoogleDriveStorage()
    }
    return this.instance
  }

  public getLastSyncTime(): number | null {
    const value = this.get(GoogleDriveData.LAST_SYNC_TIME)
    return value ? parseInt(value, 10) : null
  }

  public setLastSyncTime(timestamp: number): void {
    this.set(GoogleDriveData.LAST_SYNC_TIME, timestamp.toString())
  }
}

export const GoogleDriveStorageInstance = GoogleDriveStorage.getInstance()
